import { apiClient } from '@/services/api'
import endpoints from '@/services/endpoints'

export default {
  get: {
    async all() {
      try {
        const alerts = await apiClient.get(endpoints.alerts.all())
        return alerts
      } catch (error) {
        console.error(error)
        throw error
      }
    },

    async alert(id) {
      try {
        const alert = await apiClient.get(endpoints.alerts.get(id))
        return alert
      } catch (error) {
        console.error(error)
        throw error
      }
    },
  },

  update: {
    async alert(id, payload) {
      try {
        const alert = await apiClient.patch(endpoints.alerts.get(id), payload)
        return alert
      } catch (error) {
        console.error(error)
        throw error
      }
    },
  },
}
